export type NotificationResult = 'OK' | 'CANCEL';
